module.exports = __webpack_public_path__ + "media/images/smart_phone/item/bg_tab_off-b1a04fe6a54dcca0581f8736f3a4b3b4.png";